export const permissionsKeys = {
  page: 'param.dynamic-lists',
  pageBlockFind: 'param.dynamic-lists.content-schema.find',
  pageBlockCreate: 'param.dynamic-lists.content-schema.create',
  pageBlockUpdate: 'param.dynamic-lists.content-schema.update',
  pageBlockRemove: 'param.dynamic-lists.content-schema.remove',
  pageBlockUpdatePublish: 'param.dynamic-lists.content-schema.update',
  pageBlockUpdateStatusToDraft: 'param.dynamic-lists.content-schema.update',
  pageBlockUpdateInactivate: 'param.dynamic-lists.content-schema.update',
};
